'use strict';

import * as header from './header';
import * as scrollMagicAnimations from './scrollmagic-animations';
import * as sliders from './sliders'
import './form-domain-blacklist'

header.dropdown();
header.mobileAccordeon();
scrollMagicAnimations.headerOnScroll();
scrollMagicAnimations.revealOnScroll();
scrollMagicAnimations.scrollingText();
/*scrollMagicAnimations.revealPosts();*/
scrollMagicAnimations.moveCardsOnScroll();
scrollMagicAnimations.moveValuesOnScroll();
sliders.sliderLogos();
sliders.sliderText();
sliders.widgetSliderPortfolio();
